import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/deliverables')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/deliverable' })
  },
})
